<div class="position-relative">
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="panel-title"> {{ rolesEdit ? 'Edit' : rolesView ? 'View' :
    'Add' }} {{isShown === 'tenant' ? ('client' | translate) : 'Global'}} Roles</div>

  <form [formGroup]="rolesForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="mt-top-2 field" *ngIf="(!rolesEdit && !rolesView) && (isShown == 'tenant')">
      <!-- <label for="role" class="d-block">Do you want to:</label> -->
      <mat-radio-group class="field">
        <mat-radio-button value="new" [checked]='true' (change)="onChangeAdd($event)">Add New Role</mat-radio-button>
        <mat-radio-button value="existing" (change)="onChangeAdd($event)">Add Existing Role</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="mt-top-2 field" *ngIf="existingClicked">
      <mat-form-field class="field">
        <mat-select [disableOptionCentering]="true" placeholder="Select Existing Role" formControlName="roleList">
          <mat-option *ngFor="let role of roles; let i = index" [value]="role.roleName"
            (onSelectionChange)="getValues($event)">
            {{role.roleName | titlecase}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="make-responsive -roles-modal">
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>Name</mat-label>
          <input matInput formControlName="roleName">
          <ng-container *ngIf="formSubmitted && formValues['roleName'].errors">
            <mat-error *ngIf="formValues['roleName'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Name is required
            </mat-error>
            <mat-error *ngIf="formValues['roleName'].errors?.['pattern']">
              <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>Role Type</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="roleTypeId">
            <mat-option *ngFor="let item of roleTypeList" [value]="item._id" selected>
              {{item.roletype}}
            </mat-option>
          </mat-select>
          <ng-container *ngIf="formSubmitted && formValues['roleTypeId'].errors">
            <mat-error *ngIf="formValues['roleTypeId'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Role Type is required
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="modal-form d-flex -text-area-field-height">
        <mat-form-field>
          <mat-label>Description</mat-label>
          <textarea matInput cdkTextareaAutosize formControlName="description" #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
          <ng-container *ngIf="formSubmitted && formValues['description'].errors">
            <mat-error *ngIf="formValues['description'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Description is required
            </mat-error>
            <mat-error *ngIf="formValues['description'].errors?.['pattern']">
              <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="isShown === 'global'">
        <mat-form-field class="field">
          <mat-label>Select Scope</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="type">
            <mat-option *ngFor="let item of type; let i = index" [value]="item.name" selected>
              {{item.name | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
          class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
    </div>
    <div class="btn-basket">
      <button mat-raised-button color="primary" data-dismiss="modal" type="button" (click)="closeModal()">Close</button>
      <button *ngIf="!rolesView" mat-raised-button color="primary" type="submit">
        {{ rolesEdit ? 'Update' : 'Submit' }}
      </button>
    </div>
  </form>
</div>